export default __webpack_public_path__ + "static/media/five.89b924eb.svg";